import { render, staticRenderFns } from "./error.vue?vue&type=template&id=42212d12&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42212d12",
  null
  
)

export default component.exports